import { ValidationRule } from 'devextreme-react/common';
import { ProfileCardItem } from '../components/library/profile-card/ProfileCard';
import { POSITION_LIST } from '../shared/constants';

export const service = {
  getBasicInfoItems(): ProfileCardItem[] {
    return [
      { dataField: 'FirstName', colSpan: 2, label: 'Voornaam' },
      { dataField: 'LastName', colSpan: 2, label: 'Achternaam' },
      {
        label: 'Calender kleur',
        dataField: 'SchedulerColor',
        editorType: 'dxColorBox',
        colSpan: 1,
      },
      {
        dataField: 'Position',
        label: 'Functie',
        editorType: 'dxSelectBox',
        colSpan: 1,
        editorOptions: {
          items: POSITION_LIST,
        }
      },
      {
        dataField: 'HireDate',
        label: 'Datum in dienst',
        editorType: 'dxDateBox',
        colSpan: 1,
        editorOptions: {
          max: new Date(),
        }
      },
      {
        dataField: 'DateOfBirth',
        label: 'Verjaardag',
        colSpan: 1,
        editorType: 'dxDateBox',
        editorOptions: {
          max: new Date(),
        }
      },
      {
        label: 'Actief',
        dataField: 'Active',
        editorType: 'dxSwitch',
        colSpan: 1,
      },
    ];
  },
  getContactItems(): ProfileCardItem[] {
    return [
      {
        dataField: 'PhoneNumber',
        label: 'Telefoonnummer',
      },
      {
        dataField: 'Email',
        validators: [
          { type: 'email' }
        ] as ValidationRule[]
      },
    ];
  },
  getAddressItems(): ProfileCardItem[] {
    return [
      { dataField: 'City', label: 'Woonplaats' },
      {
        dataField: 'Address',
        label: 'Adres',
        colSpan: 2,
      },
      {
        dataField: 'PostalCode',
        label: 'Poastcode',
        colSpan: 2,
      },
    ];
  }
};
